// RequireEmailVerified.js

import React, { useContext } from 'react';
import { AuthContext } from 'context'; // Assuming AuthContext provides user/profile data
import VerifyEmailModal from "auth/resend-verification";

const RequireEmailVerified = ({ isVerified, loading, initialLoadComplete, children }) => {
    // 1. Loading state (Wait for verification check to finish)
    if ((loading || isVerified === null) && !initialLoadComplete) {
        return null; // Or render a global loading indicator
    }

    // 2. Restriction Check
    if (isVerified === false) {
        // Render the modal if the check fails
        return <VerifyEmailModal open={true} />;
    }

    // 3. Pass through (Render the next component in the chain)
    return children;
};

export default RequireEmailVerified;